import { api } from '@/integrations/clients/carAuction/carAuctionClient';
import { NewsItem, GetAllNewsParams, GetNewsResponse } from '@/types/news';
import { mapUserTypeToTargetUserType } from '@/utils/newsUtils';

export class NewsService {
  // Get all news for public use (only visible news)
  static async getAllNews(params: GetAllNewsParams): Promise<NewsItem[]> {
    const targetUserType = mapUserTypeToTargetUserType(params.userType);
    
    const response = await api.get<GetNewsResponse>(`/news`, {
      params: targetUserType ? {
        targetUserType,
      } : {},
    });

    // api.get already returns response.data, so response is GetNewsResponse directly
    // GetNewsResponse is { success: true, total: number, data: NewsDto[] }
    // So response.data is NewsDto[]
    const newsData = response.data || [];
    
    // Backend already maps to frontend format, just convert Date strings to Date objects
    return newsData.map((item) => ({
      ...item,
      createdAt: item.createdAt ? new Date(item.createdAt) : new Date(),
      updatedAt: item.updatedAt ? new Date(item.updatedAt) : new Date(),
    })) as NewsItem[];
  }
}
